import Vue from 'vue';
import i18n from "./i18n/i18n";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import vueBar from 'vuebar';
import { router } from "./router";
import VeeValidate from 'vee-validate'
import store from "./store/index";
import axios from './axios/axios';
import YmapPlugin from 'vue-yandex-maps';

import config from './config/validate';

import locales from './locale';
let locale = locales[i18n.locale];

/*added font awesome icons, ElementUI icons not enough*/
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

/* vue2vis css */
import 'vue2vis/dist/vue2vis.css';


Vue.use(ElementUI, { locale });
Vue.use(VeeValidate, config);
Vue.config.productionTip = false;
Vue.use(vueBar);
Vue.prototype.$http = axios;
Vue.use(YmapPlugin, {
  apiKey: '39b3fad2-ca0e-40c2-a870-9663276e5d61',
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
